import React from 'react';

import {
  CardMedia,
} from '@mui/material';

import { service } from '@/share';

/**
 * プロパティ
 */
export type Props = {
  /** 施設ID */
  nurseryId: string,
  /** S3パス */
  s3Path: string,
  /** クリック */
  onClick: () => void,
  /** ALT */
  alt: string,
  /** 透明度 */
  opacity?: number | undefined,
  /** 幅 */
  width?: number | undefined,
  /** 高さ */
  height?: number | undefined,
  /** フィット方法 */
  objectFit?: 'cover' | 'contain' | 'scale-down' | 'none' | undefined,
  /** url指定 */
  dataUrl?: string | undefined,
};

const CardMediaImage: React.FC<Props> = ({
  nurseryId,
  s3Path,
  width,
  height,
  opacity,
  onClick,
  alt,
  objectFit,
  dataUrl,
}) => {
  const [url, setUrl] = React.useState(dataUrl || 'images/loading.png');
  React.useEffect(() => {
    const execProcess = async () => {
      if (!dataUrl) {
        if (s3Path) {
          const blob = await service.file.getImageBlob(s3Path, nurseryId);
          if (blob) {
            setUrl(URL.createObjectURL(blob));
          } else {
            setUrl('images/noimage.png');
          }
        } else {
          setUrl('images/noimage.png');
        }
      }
    };
    execProcess();
  }, [s3Path, nurseryId, dataUrl]);
  return (
    <CardMedia
      component="img"
      image={url}
      alt={alt}
      loading="lazy"
      style={{
        opacity,
        objectFit,
        width,
        height,
        cursor: 'pointer',
      }}
      onError={(e) => {
        e.currentTarget.src = 'images/noimage.png';
      }}
      onClick={() => onClick()}
    />
  );
};

export default CardMediaImage;
